// Data
import products from "~/data/products.json";

// Deps
import { selectStyles } from "~/styleguide/forms";
import { createComponent } from "react-fela";

// Components
import MultiSelect from "~/components/shared/form/multi-select";

// Grab products with more than one published resource
const options = products
    .map(product => {
        return { value: product.id, label: product.name, count: product.count };
    })
    .filter(({ count }) => count && count > 0);

export default function ProductsFilter({ handleProductsChange, selected }) {
    // Can't filter by types if there are none
    if (!products || !products.length) return null;

    return (
        <Container>
            <p style={{ fontSize: "14px", marginBottom: "12px" }}>
                Products
            </p>

            <MultiSelect
                options={options}
                onChange={handleProductsChange}
                selected={selected}
                type="Products"
            />
        </Container>
    );
}

const Container = createComponent(() => ({
    ...selectStyles
}));
